// Import react elements
import { useCallback, useContext, useState } from 'react';

// Import context function
import { AuthContext } from "global/context/AuthContext";

// Import strich api calls
import {
    getCustomProducts,
    getCustomProduct,
    addCustomProduct,
    updateCustomProduct,
    deleteCustomProduct,
    getCustomProductColourways,
    addCustomProductColourway,
    updateCustomProductColourway,
    deleteCustomProductColourway,
    addCustomProductSurface,
    updateCustomProductSurface,
    deleteCustomProductSurface,
    addCustomProductPrintArea,
    updateCustomProductPrintArea,
    deleteCustomProductPrintArea,
    updateCustomProductPrintLayout,
    getPrintAreaRoles,

    addUpdateRelativePosition,
    getCustomProductPositionCloneTargets,
    cloneCustomProductPosition,
    deleteRelativePosition,
    updateCustomProductView,
    deleteCustomProductView,
    getCustomProductMockup,
    getCustomProductMockupCloneTargets,
    cloneCustomProductMockup,
    updateCustomProductMockup,
    deleteCustomProductMockup,
    deleteCustomProductPrintLayout,

    getCustomProductsMaterials,
    getCustomProductsMethods,
    getCustomProductsModes,
    updateAddCustomProductsMaterial,
    updateAddCustomProductsMethod,
    updateAddCustomProductsMode,
    deleteCustomProductsMaterial,
    deleteCustomProductsMethod,
    deleteCustomProductsMode,
    createMMMLink,
    getMMMLinks,
    deleteMMMLink
} from "api/APIStrichCalls";




// Custom hook to manage fetching, filtering, updating, and uploading images
const useCustomProductsData = () => {

    // Get the token from AuthContext
    const { token } = useContext(AuthContext);

    // Store details
    const [customProducts, setCustomProducts] = useState(null);

    const [customProductsMaterials, setCustomProductsMaterials] = useState([]);
    const [customProductsMethods, setCustomProductsMethods] = useState([]);
    const [customProductsModes, setCustomProductsModes] = useState([]);
    const [customProductsMMMLinks, setCustomProductsMMMLinks] = useState([]);

    // Loading state for fetching custom products
    const [loadingCustomProducts, setLoadingCustomProducts] = useState(false);



    // --- Fetching Custom Products ---

    // Function to fetch custom products 
    const fetchCustomProducts = async (customProductCode, surfaceData, printAreaDataCode) => {
        
        // Set loading state
        setLoadingCustomProducts(true);

        // Wait for the details to resolve
        const response = await getCustomProducts(token);

        // If successful
        if (response?.success && response.results) {

            // Edit the data if we need to

            // Set the result in state
            setCustomProducts(response.results);
           
        } else {

            console.log("Couldn't fetch custom products.");

        }

        // Clear loading state
        setLoadingCustomProducts(false);

        // Create what we want to return based on whether ids/code have been sent (because we currently have things selected and want to keep them selected but updated)

        // If a custom product id has been provided then find the product in the response - NOPE NEED TO MAKE A CALL FOR THE SPECIFIC PRODUCT TO GET ALL THE DATA
        const reselectedCustomProduct = customProductCode ? await fetchCustomProduct(customProductCode) : null;

        // If a surface id has been provided then find the surface in the product found above
        const reselectedSurface = surfaceData ? reselectedCustomProduct.surfaces.find((surface) => surface.code === surfaceData.details.code) : null;

        // If a print area code has been provided then find the print area in the product found above
        const reselectedPrintArea = printAreaDataCode ? reselectedSurface.print_areas.find((printArea) => printArea.code === printAreaDataCode) : null;

        // Make the final response
        const finalResponse = 

            // If we have a selected product and surface and print area then set them in the final response
            reselectedCustomProduct && reselectedSurface && reselectedPrintArea? {selectedProduct: reselectedCustomProduct, selectedSurface: {details: reselectedSurface, index: surfaceData.index}, selectedPrintArea: reselectedPrintArea}

            // If we have a selected product and surface then set them in the final response
            : reselectedCustomProduct && reselectedSurface ? {selectedProduct: reselectedCustomProduct, selectedSurface: {details: reselectedSurface, index: surfaceData.index}}
        
            // If we just have a selected product then set it in the final response
            : reselectedCustomProduct ? {selectedProduct: reselectedCustomProduct} 

                // We don't have a selected product so just return the api response
                : response.results;


        //console.log("response.results: ", response.results);
        //console.log("customProductID: ", customProductID);

        //console.log("stuff: ", customProductCode, surfaceData, printAreaDataCode);
        //console.log("returned: ", finalResponse);

        return finalResponse;

    };



    // Function to fetch custom products 
    const fetchCustomProduct = async (customProductCode) => {

        // Set loading state

        // Wait for the details to resolve - incl_mockup = "Y" and incl_print_layout = "Y"
        const response = await getCustomProduct(token, customProductCode, "Y", "Y");

        // If successful
        if (response?.success && response.results) {

            // Edit the data if we need to

            // Set the result in state
            //setCustomProduct(response.results);
           
        } else {

            console.log("Couldn't fetch custom product: "  + customProductCode);

        }

        return response.results.product;

    };



    // --- Add Custom Product ---

    const addNewCustomProduct = async (customProductData) => {

        // Wait for the details to resolve
        const response = await addCustomProduct(token, customProductData);

        // If successful
        if (response?.success) {

            // Refecth the custom products to include our new one
            fetchCustomProducts();

        } 

        return response;

    };

    // --- Update Custom Product ---

    const updateExistingCustomProduct = async (customProductCode, customProductData) => {

        // Wait for the details to resolve
        const response = await updateCustomProduct(token, customProductCode, customProductData);

        // If successful
        if (response?.success) {

            // Refecth the custom products to include our updated one
            fetchCustomProducts();

        } 

        return response;

    };

    // --- Delete Custom Product ---

    const removeCustomProduct = async (customProductCode) => {

        // Wait for the details to resolve
        const response = await deleteCustomProduct(token, customProductCode);

        // If successful
        if (response?.success) {

            // Refetch the custom products to exclude the one we've just deleted
            fetchCustomProducts();

        } 

        return response;

    }

        // --- Fetch Custom Product Colourways ---

    const fetchCustomProductColourways = async (customProductCode) => {

        // Wait for the colourways to resolve
        const response = await getCustomProductColourways(token, customProductCode);

        // If successful
        if (response?.success && response.results) {

            // Return the colourways from the response
            return response.results;

        } else {

            console.log("Couldn't fetch custom product colourways: "  + customProductCode);

        }

        // Return an empty array if no colourways were found
        return [];

    };



    // --- Add new COLOURWAY ---

    const addNewCustomProductColourway = async (customProductCode, colourwayData, setSelectedCustomProduct) => {

        // Wait for the colourway add call to resolve
        const response = await addCustomProductColourway(token, customProductCode, colourwayData);

        // If successful
        if (response?.success) {

            // Refetch the custom product to include the new colourway
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        }

        return response;

    };



    // --- Update existing COLOURWAY ---

    const updateExistingColourway = async (customProductCode, originalColourwayCode, colourwayData, setSelectedCustomProduct) => {

        // Wait for the colourway update call to resolve
        const response = await updateCustomProductColourway(token, customProductCode, originalColourwayCode, colourwayData);

        // If successful
        if (response?.success) {

            // Refetch the custom product to include the updated colourway
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        }

        return response;

    };



    // --- Delete existing COLOURWAY ---

    const deleteColourway = async (customProductCode, colourwayCode, setSelectedCustomProduct) => {

        // Wait for the colourway delete call to resolve
        const response = await deleteCustomProductColourway(token, customProductCode, colourwayCode);

        // If successful
        if (response?.success) {

            // Refetch the custom product to remove the deleted colourway from the selected product
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        }

        return response;

    };


    // --- Add new SURFACE ---

    const addNewCustomProductSurface = async (customProductSurfaceData, customProductCode, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await addCustomProductSurface(token, customProductCode, customProductSurfaceData);

        // If successful
        if (response?.success) {

            // Refecth the custom products to include our new one
            const repsonse = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(repsonse.selectedProduct);

        } 

        return response;

    };

    // --- Update existing SURFACE ---

    const updateExistingSurface = async (customProductCode, originalSurfaceCode, newSurfaceData, customProductID, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await updateCustomProductSurface(token, customProductCode, originalSurfaceCode, newSurfaceData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our new one
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        } 

        return response;    

    };

    // --- Delete existing SURFACE ---

    const deleteSurface = async (customProductCode, surfaceCode, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await deleteCustomProductSurface(token, customProductCode, surfaceCode);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        } 

        return response;

    }



    // --- Add new PRINT AREA
    
    const addNewCustomProductPrintArea = async (customProductSurfaceData, customProductCode, surfaceData, setSelectedCustomProduct, setSelectedSurfaceData) => {

        // Wait for the details to resolve
        const response = await addCustomProductPrintArea(token, customProductCode, surfaceData.details.code, customProductSurfaceData);

        // If successful
        if (response?.success) {

            // Refecth the custom products to include our new one
            const response = await fetchCustomProducts(customProductCode, surfaceData);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface)

        } 

        return response;

    };

    
    // --- Update existing PRINT AREA ---

    const updateExistingPrintArea = async (customProductCode, surfaceData, originalPrintAreaCode, newPrintAreaData, setSelectedCustomProduct, setSelectedSurfaceData, setSelectedPrintAreaData) => {

        // Wait for the details to resolve
        const response = await updateCustomProductPrintArea(token, customProductCode, surfaceData.details.code, originalPrintAreaCode, newPrintAreaData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode, surfaceData, newPrintAreaData.code);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };

    // --- Reorder PRINT AREAS ---

    const reorderPrintAreas = async (customProductCode, surfaceData, orderedPrintAreas, setSelectedCustomProduct, setSelectedSurfaceData) => {

        // Check that we have everything required to update the ordering
        if (!customProductCode || !surfaceData?.details?.code || !Array.isArray(orderedPrintAreas)) {
            return { success: false, error_message: "Print area ordering data is invalid" };
        }

        // Go through the complete requested order so the database ends up with a clean 1..n sequence
        for (let index = 0; index < orderedPrintAreas.length; index += 1) {

            // Get the print area at this position
            const printArea = orderedPrintAreas[index];

            // Ordering is one-based in the API
            const newOrdering = index + 1;

            // Do not make an API call when this print area is already in the correct position
            if (Number(printArea.ordering) === newOrdering) {
                continue;
            }

            // Update only the print area code and ordering
            const response = await updateCustomProductPrintArea(
                token,
                customProductCode,
                surfaceData.details.code,
                printArea.code,
                {
                    code: printArea.code,
                    ordering: newOrdering
                }
            );

            // Stop immediately if one of the ordering updates fails
            if (!response?.success) {

                // Refetch so the UI reflects whatever ordering actually reached the database
                const refreshResponse = await fetchCustomProducts(customProductCode, surfaceData);

                // Update the selected product if the refresh succeeded
                if (refreshResponse?.selectedProduct) {
                    setSelectedCustomProduct(refreshResponse.selectedProduct);
                }

                // Update the selected surface if the refresh succeeded
                if (refreshResponse?.selectedSurface) {
                    setSelectedSurfaceData(refreshResponse.selectedSurface);
                }

                return response;
            }

        }

        // Refetch once after all ordering updates have completed
        const refreshResponse = await fetchCustomProducts(customProductCode, surfaceData);

        // Check that the refreshed product and surface were returned
        if (!refreshResponse?.selectedProduct || !refreshResponse?.selectedSurface) {
            return { success: false, error_message: "Print areas were reordered but the updated surface could not be reloaded" };
        }

        // Update the selected product
        setSelectedCustomProduct(refreshResponse.selectedProduct);

        // Update the selected surface so the cards immediately appear in their new order
        setSelectedSurfaceData(refreshResponse.selectedSurface);

        // Return success to the page
        return { success: true };

    };

    // --- Delete existing PRINT AREA ---

    const deletePrintArea = async (customProductCode, surfaceData, printAreaCode, customProductID, setSelectedCustomProduct, setSelectedSurfaceData) => {

        // Wait for the details to resolve
        const response = await deleteCustomProductPrintArea(token, customProductCode, surfaceData.details.code, printAreaCode);

        // If successful
        if (response?.success) {

            // Refetch the product and its currently selected surface so the persistent editor tree is immediately current
            const refreshResponse = await fetchCustomProducts(customProductCode, surfaceData);

            // Update the selected product when it was reloaded successfully
            if (refreshResponse?.selectedProduct) {
                setSelectedCustomProduct(refreshResponse.selectedProduct);
            }

            // Update the selected surface so the deleted print area disappears from its child list immediately
            if (refreshResponse?.selectedSurface) {
                setSelectedSurfaceData(refreshResponse.selectedSurface);
            }

        } 

        return response;

    }


    // -- Get the PRINT AREA ROLES
    const fetchPrintAreaRoles = async (setPrintAreaRoles) => {

        const response = await getPrintAreaRoles(token);

        setPrintAreaRoles(response.results);

    };


    // --- Add / Update Relative Position
    
    const addUpdatePosition = async (customProductCode, surfaceData, printAreaCode, newPositionData, setSelectedCustomProduct, setSelectedSurfaceData, setSelectedPrintAreaData) => {

        // Wait for the details to resolve
        const response = await addUpdateRelativePosition(token, customProductCode, surfaceData.details.code, printAreaCode, newPositionData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode, surfaceData, printAreaCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };


    // -- Delete Relative Position    // -- Get POSITION clone targets

    const getPositionCloneTargets = useCallback(async (customProductCode, surfaceCode, printAreaCode, positionCode) => {

        // Return compatible sibling / child destinations for this saved position
        return await getCustomProductPositionCloneTargets(token, customProductCode, surfaceCode, printAreaCode, positionCode);

    }, [token]);


    // -- Clone POSITION

    const clonePosition = async (customProductCode, targetProductCode, surfaceCode, printAreaCode, positionCode) => {

        // Clone the saved position without changing the currently selected source product
        return await cloneCustomProductPosition(token, customProductCode, targetProductCode, surfaceCode, printAreaCode, positionCode);

    };


    // -- Delete Relative Position

    const deletePosition = async (customProductCode, surfaceData, printAreaCode, positionCode, setSelectedCustomProduct, setSelectedSurfaceData, setSelectedPrintAreaData) => {

        // Wait for the details to resolve
        const response = await deleteRelativePosition(token, customProductCode, surfaceData.details.code, printAreaCode, positionCode);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode, surfaceData, printAreaCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };
    

    // -- Update VIEW

    const updateView = async (customProductCode, surfaceData, printAreaCode, viewStyle, viewName, viewData, setSelectedCustomProduct, setSelectedSurfaceData, setSelectedPrintAreaData) => {

        // Wait for the details to resolve
        const response = await updateCustomProductView(token, customProductCode, surfaceData.details.code, printAreaCode, viewStyle, viewName, viewData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode, surfaceData, printAreaCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            setSelectedPrintAreaData(response.selectedPrintArea);

        }

        return response;

    };


    // -- Delete VIEW

    const deleteView = async (customProductCode, surfaceData, printAreaCode, viewStyle, viewName, setSelectedCustomProduct, setSelectedSurfaceData, setSelectedPrintAreaData) => {

        // Wait for the details to resolve
        const response = await deleteCustomProductView(token, customProductCode, surfaceData.details.code, printAreaCode, viewStyle, viewName);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode, surfaceData, printAreaCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };

    // -- Fetch one complete MOCKUP for editing

    const fetchMockup = useCallback(async (mockID) => {

        return await getCustomProductMockup(token, mockID);

    }, [token]);


    // -- Get MOCKUP clone targets

    const getMockupCloneTargets = useCallback(async (customProductCode, mockID) => {

        return await getCustomProductMockupCloneTargets(token, customProductCode, mockID);

    }, [token]);


    // -- Clone MOCKUP

    const cloneMockup = async (customProductCode, mockID, targetProductCode, allChildren = "N") => {

        return await cloneCustomProductMockup(token, mockID, customProductCode, targetProductCode, allChildren);

    };

    // -- Update MOCKUP

    const updateMockup = async (customProductCode, mockID, mockupData, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await updateCustomProductMockup(token, customProductCode, mockID, mockupData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

        }

        return response;

    };


    // -- Delete MOCKUP

    const deleteMockup = async (customProductCode, mockID, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await deleteCustomProductMockup(token, customProductCode, mockID);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            //setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            //setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };

    // --- Update Print Layout
    
    const updatePrintLayout = async (customProductCode, printLayoutID, newPrintLayoutData, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await updateCustomProductPrintLayout(token, printLayoutID, newPrintLayoutData);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const refreshedData = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(refreshedData.selectedProduct);

            // Find the freshly loaded print layout
            const refreshedPrintLayout = refreshedData.selectedProduct?.print_layouts?.find((printLayout) => String(printLayout.id) === String(printLayoutID));

            // Return the refreshed print layout with the update response
            return { ...response, print_layout: refreshedPrintLayout || null };

        } 

        return response;    

    };

    // -- Delete PRINT LAYOUT

    const deletePrintLayout = async (customProductCode, printLayoutID, setSelectedCustomProduct) => {

        // Wait for the details to resolve
        const response = await deleteCustomProductPrintLayout(token, customProductCode, printLayoutID);

        // If successful
        if (response?.success) {

            // Refetch the custom products to include our updated one
            const response = await fetchCustomProducts(customProductCode);

            // Set the selected product
            setSelectedCustomProduct(response.selectedProduct);

            // Set selected surface to update immediately
            //setSelectedSurfaceData(response.selectedSurface);

            // Set selected print area to update immediately
            //setSelectedPrintAreaData(response.selectedPrintArea);

        } 

        return response;    

    };






    // --- Fetching MMMs ---

    // Function to fetch custom products materials
    const fetchCustomProductsMaterials = async () => {

        // Wait for the details to resolve
        const response = await getCustomProductsMaterials(token);

        // If successful
        if (response?.success && response.results) {

            // Set the result in state
            setCustomProductsMaterials(response.results);

        } else {

            console.log("Couldn't fetch materials.");

        }

        return response.results;

    };

    // Function to fetch custom products methods
    const fetchCustomProductsMethods = async () => {

        // Wait for the details to resolve
        const response = await getCustomProductsMethods(token);

        // If successful
        if (response?.success && response.results) {

            // Set the result in state
            setCustomProductsMethods(response.results);

        } else {

            console.log("Couldn't fetch methods.");

        }

        return response.results;

    };

    // Function to fetch custom products modes
    const fetchCustomProductsModes = async () => {

        // Wait for the details to resolve
        const response = await getCustomProductsModes(token);

        // If successful
        if (response?.success && response.results) {

            // Set the result in state
            setCustomProductsModes(response.results);

        } else {

            console.log("Couldn't fetch modes.");

        }

        return response.results;

    };



    // Add / Update MMMs

    // Function to update a custom products material
    const updateAddCustomProductsMMM = async (type, payload) => {

        // Set the api call based on the MMM type
        const apiCall = type === "Materials" ? updateAddCustomProductsMaterial : type === "Methods" ? updateAddCustomProductsMethod : type === "Modes" ? updateAddCustomProductsMode : "";

        // Wait for the details to resolve
        const response = await apiCall(token, payload);

        return response;

    };



    // Deleting MMMs

    // Function to update a custom products material
    const removeCustomProductsMMM = async (type, ID) => {

        const payload = {
            id: ID
        }

        // Set the api call based on the MMM type
        const apiCall = type === "Materials" ? deleteCustomProductsMaterial : type === "Methods" ? deleteCustomProductsMethod : type === "Modes" ? deleteCustomProductsMode : "";

        // Wait for the details to resolve
        const response = await apiCall(token, ID, payload);

        return response;

    };



    // Create MMM Link

    // Function to create / update a custom products MMM link
    const createLink = async (material_id, method_id, mode_id, payload) => {

        // Wait for the details to resolve
        const response = await createMMMLink(token, material_id, method_id, mode_id, payload);

        return response;

    };



    // Delete MMM Link

    const removeMMMLink = async (linkDetails) => {

        // Wait for the delete to resolve
        const response = await deleteMMMLink(token, linkDetails.material_id, linkDetails.method_id, linkDetails.mode_id);

        return response;

    };



    // Fetch MMM Links

    // Function to fetch custom products MMM links
    const fetchCustomProductsLinks = async () => {

        // Wait for the details to resolve
        const response = await getMMMLinks(token);

        // If successful
        if (response?.success && response.results) {

            // Set the result in state
            setCustomProductsMMMLinks(response.results);

        } else {

            console.log("Couldn't fetch modes.");

        }

        return response.results;

    };



    // Function to update links array with M_name ( look up from MMMs ) because we want the readable names not just ids
    function AttachNamesToLinks(links, mmmArray, mmmType) {

        // Build an id <-> name lookup that accepts either an object map or an array
        const idToName = Array.isArray(mmmArray)

            // If it's an array like [{ id, name }]
            ? mmmArray.reduce((acc, m) => {

                // Guard against missing fields
                const key = String(m?.id ?? "");

                // Only assign when key and name exist
                if (key && typeof m?.name === "string") acc[key] = m.name;

                // Return accumulator
                return acc;

            }, {})

            // Otherwise assume it's already an object map like { "1": "Cotton" } - probably don't need this
            : Object.fromEntries(

                // Normalize keys to strings for safer lookup
                Object.entries(mmmArray || {}).map(([k, v]) => [String(k), v])

                );

            // Return a new array with M_name added
            return (links || []).map((link, index) => {

                // Clone to avoid mutating original
                const next = { ...link };

                // Build a padded index part so sorting by string still works (0001, 0002, 0010, etc.)
                const indexPart = String(index).padStart(4, "0");

                // Build id based on material_id + method_id + mode_id - This will be a string like "137" if ids are 1, 3, 4
                const baseId = `${link?.material_id ?? ""}${link?.method_id ?? ""}${link?.mode_id ?? ""}`;

                // Final id with index at the front
                next.id = `${indexPart}-${baseId}`;

                // Normalize the M_id to string
                const key = mmmType === "material" ? String(link?.material_id ?? "") : mmmType === "method" ? String(link?.method_id ?? "") : String(link?.mode_id ?? "");

                if (mmmType === "material") {

                    // Add the new _name field (empty string if no match)
                    next.material_name = idToName[key] ?? "";

                } else if (mmmType === "method") {

                    // Add the new _name field (empty string if no match)
                    next.method_name = idToName[key] ?? "";

                }  else {

                    // Add the new _name field (empty string if no match)
                    next.mode_name = idToName[key] ?? "";

                }

                // Done
                return next;

            });

    };



    // Function to get all MMMs and also return them
    const fetchMMMs = async (setMaterials, setMethods, setModes) => {

        // Fetch materials from API
        const freshMaterials = await fetchCustomProductsMaterials();

        // Store materials in state
        setMaterials(freshMaterials);

        // Fetch methods from API
        const freshMethods = await fetchCustomProductsMethods();

        // Store methods in state
        setMethods(freshMethods);

        // Fetch modes from API
        const freshModes = await fetchCustomProductsModes();

        // Store modes in state
        setModes(freshModes);

        // Return the fresh MMM data so callers can use it immediately
        return {

            // Return the materials array
            materials: freshMaterials,

            // Return the methods array
            methods: freshMethods,

            // Return the modes array
            modes: freshModes

        };

    };




    // Function to fetch and format links
    const fetchAndFormatCustomProductMMMLinks = async (setLinks, setLoading, materials, methods, modes) => {

        // Set loading state 
        setLoading(true);

        try {

            // Make the call
            const linksWithIds = await fetchCustomProductsLinks();

            // Format the data - Add names to links (currently only MMM ids)
            const linksWithMaterialNames = await AttachNamesToLinks(linksWithIds, materials, "material");
            const linksWithMaterialAndMethodNames = await AttachNamesToLinks(linksWithMaterialNames, methods, "method");
            const linksWithNames = await AttachNamesToLinks(linksWithMaterialAndMethodNames, modes, "mode");

            // Check if a state to set has been provided
            if (setLinks) {

                // Set links to above
                setLinks(linksWithNames);

            } else {

                // Set local state
                setCustomProductsMMMLinks(linksWithNames);

            }

        } catch {

        } finally {
                
            // Clear loading state
            setLoading(false);

        }

    };



    return {

        fetchCustomProducts,
        fetchCustomProduct,
        loadingCustomProducts,
        customProducts,
        addNewCustomProduct,
        updateExistingCustomProduct,
        removeCustomProduct,
        fetchCustomProductColourways,
        addNewCustomProductColourway,
        updateExistingColourway,
        deleteColourway,
        addNewCustomProductSurface,
        updateExistingSurface,
        deleteSurface,
        addNewCustomProductPrintArea,
        updateExistingPrintArea,
        reorderPrintAreas,
        deletePrintArea,
        updatePrintLayout,
        fetchPrintAreaRoles,

        addUpdatePosition,
        getPositionCloneTargets,
        clonePosition,
        updateView,
        deletePosition,
        deleteView,
        fetchMockup,
        getMockupCloneTargets,
        cloneMockup,
        updateMockup,
        deleteMockup,
        deletePrintLayout,

        fetchCustomProductsMaterials,
        customProductsMaterials,
        fetchCustomProductsMethods,
        customProductsMethods,
        fetchCustomProductsModes,
        customProductsModes,
        updateAddCustomProductsMMM,
        removeCustomProductsMMM,
        createLink,
        fetchCustomProductsLinks,

        fetchMMMs,
        fetchAndFormatCustomProductMMMLinks,
        

        customProductsMMMLinks,
        removeMMMLink

    };

};

export default useCustomProductsData;   